/**
 * This file is part of the "Awaken Media" project.
 *
 * (c) 2017 - CanalPlus International
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import React from 'react';

import breakpoints from 'shared/constants/breakpoints';
import Arrow from '../core/Arrow';

export default {
  headers: {
    nextArrow: <Arrow />,
    prevArrow: <Arrow />,
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 0,
    responsive: [
      {
        breakpoint: breakpoints.tablet,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  },
  grid: {
    dots: false,
    arrows: false,
    infinite: false,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 0,
    responsive: [
      {
        breakpoint: breakpoints.tablet,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  }
};
